import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const H2 = styled.h2`
  font-family: 'Nunito', sans-serif;
  font-weight: 700;
  font-size: 38px;
  line-height: 48px;
  color: ${props => props.light ? 'white' : '#505663'};
  padding: 45px 5%;
  width: 90%;
  text-align: center;
  @media (min-width: ${breakpoints.desktop}) {
    font-size: 48px;
    line-height: 68px;
    width: 640px;
    padding: 45px 0;
  }
`;

export default H2;



// WEBPACK FOOTER //
// ./src/styled-components/H2.js